export default [{
  path: '/projecao-brr',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'Projecao de BRR Historico',
      path: 'historico',
      component: () => import('@/views/projecaoBrr/Historico.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Projeção de BRR' }
        ]
      }
    },
    {
      name: 'Projecao de BRR Editar',
      path: 'edit/:id',
      component: () => import('@/views/projecaoBrr/Edit.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Projeção de BRR', path: '/projecao-brr/historico' },
          { name: 'Editar' }
        ]
      }
    },
    {
      name: 'Projecao de BRR Adicionar',
      path: 'edit',
      component: () => import('@/views/projecaoBrr/Edit.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Projeção de BRR', path: '/projecao-brr/historico' },
          { name: 'Adicionar' }
        ]
      }
    }
  ]
}]